import { EVirtualVoucherStatus } from "@/utilities/types/Voucher";
import { PiMagnifyingGlassBold } from "react-icons/pi";
import { Input, Select } from "rizzui";

export default function FilterElement({
  onSearch,
  searchTerm,
  updateFilter,
  filters,
}: {
  onSearch: (searchTerm: string) => void;
  searchTerm: string;
  updateFilter: (key: string, value: string | undefined) => void;
  filters?: Record<string, unknown>;
  variant?: string;
}) {
  function clearSearch() {
    onSearch("");
  }

  const statusOptions = [
    { value: "all", label: "All Status" },
    { value: EVirtualVoucherStatus.USED, label: "Used" },
    { value: EVirtualVoucherStatus.USING, label: "Using" },
    { value: EVirtualVoucherStatus.NOT_USED, label: "Not Used" },
  ];

  const handleStatusChange = (value: string) => {
    updateFilter(
      "status",
      value === "all" ? undefined : (value as EVirtualVoucherStatus),
    );
  };

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 lg:flex-nowrap mb-3">
      <div className="flex flex-col md:flex-row w-full items-center gap-3 md:w-auto">
        <Input
          type="search"
          placeholder="Search by user"
          value={searchTerm}
          onClear={clearSearch}
          onChange={(e) => onSearch(e.target.value)}
          clearable={true}
          prefix={<PiMagnifyingGlassBold className="h-4 w-4" />}
          className="w-full"
          label="Search"
        />
        {/*<Select*/}
        {/*  placeholder="Select Status"*/}
        {/*  options={statusOptions}*/}
        {/*  value={filters?.status || "all"}*/}
        {/*  onChange={handleStatusChange}*/}
        {/*  className="min-w-[140px]"*/}
        {/*  getOptionValue={(option) => option.value}*/}
        {/*  displayValue={(value) => {*/}
        {/*    const option = statusOptions.find(*/}
        {/*      (option) => option.value === value*/}
        {/*    );*/}

        {/*    return option?.label ? option.label : "All Status";*/}
        {/*  }}*/}
        {/*  label="Filter by status"*/}
        {/*  clearable={!!filters?.status as boolean}*/}
        {/*  onClear={() => updateFilter("status", undefined)}*/}
        {/*/>*/}
      </div>
      {/* <div className="w-full md:w-auto flex gap-3">
        {promotionId && (
          <Button
            variant="outline"
            onClick={() => updateFilter("promotionId", undefined)}
          >
            Clear Filter
          </Button>
        )}
      </div> */}
    </div>
  );
}
